import React from 'react'
import { withRouter } from 'react-router-dom'
// import AppBar from '@material-ui/core/AppBar'
// import Toolbar from '@material-ui/core/Toolbar'
import { LayoutBase } from '.'
// import { Header } from 'components/header'
import { withStyles } from '@material-ui/styles'
import { styles } from './layout.css'

class AnonymousLayout extends LayoutBase {
  renderContent () {
    return (
      <React.Fragment>
        {/* <AppBar position='fixed' elevation={0} color='primary'>
          <Toolbar>
            <Header />
          </Toolbar>
        </AppBar> */}
        <div id='wrapper'>
          <div id='page-content-wrapper'>
            <div className='container-fluid'>
              {this.props.children}
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

export default withStyles(styles)(withRouter(AnonymousLayout))
